export var plainComparator = function plainComparator(key, descending) {
  return function (a, b) {
    var aValue = key === undefined ? a : a[key];
    var bValue = key === undefined ? b : b[key];
    return (descending ? 1 : -1) * (bValue || '').toString().localeCompare((aValue || '').toString());
  };
};